var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attr-slider"},[_c('vue-slider',{attrs:{"value":_vm.defaultValue,"min":_vm.attribute.min,"max":_vm.attribute.max,"marks":true,"tooltip":'always',"dotSize":26,"tooltip-formatter":_vm.format,"direction":_vm.direction},on:{"change":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }